import React, { useState, useEffect } from "react";
import { Form, Typography, notification } from "antd";

import OpstiPodaci from "./OpstiPodaci";
import FinansijskiPodaci from "./FinansijskiPodaci";

const { Title, Text } = Typography;

const AddEditForm = ({ isAddSupplier, supplierState, actions, brands }) => {
  const [form] = Form.useForm();
  const [opstiPodaci, setOpstiPodaci] = useState({});
  const [finansijskiPodaciForm, setFinansijskiPodaciForm] = useState(false);

  useEffect(() => {
    actions.getBrands();
    console.log(brands);
  }, []);

  const layout = !finansijskiPodaciForm
    ? {
        labelCol: { span: 6 },
        wrapperCol: { span: 17 },
      }
    : {
        labelCol: { span: 12 },
        wrapperCol: { span: 10 },
      };

  const goForward = async () => {
    try {
      await form.validateFields([
        "kompanija",
        "id",
        "adresa",
        "ovlašten",
        "telefon",
        "lokacija",
        "brand",
      ]);
      setOpstiPodaci(await form.getFieldsValue());
      setFinansijskiPodaciForm(true);
    } catch (error) {
      console.log(error);
    }
  };

  const goBack = () => {
    setFinansijskiPodaciForm(false);
  };

  const onFinish = (values) => {
    const dobavljac = {
      supplier: {
        companyName: opstiPodaci.kompanija,
        IdNumber: opstiPodaci.id,
        VATNumber: opstiPodaci.pdv,
        address: opstiPodaci.adresa,
        // logo: opstiPodaci.logo ? opstiPodaci.logo : "",
        authorizedPerson: opstiPodaci.ovlašten,
        phoneNumber: opstiPodaci.telefon,
        location: opstiPodaci.lokacija,
        minDuration: values["trajanje-min"],
        defaultDuration: values["trajanje-def"],
        maxDuration: values["trajanje-max"],
        minAmount: values["iznos-min"],
        defaultAmount: values["iznos-def"],
        maxAmount: values["iznos-max"],
        minDownPayment: values["akontacija-min"],
        defaultDownPayment: values["akontacija-def"],
        maxDownPayment: values["akontacija-max"],
        minParticipation: values["ucesce-min"],
        defaultParticipation: values["ucesce-def"],
        maxParticipation: values["ucesce-max"],
        minProcessingFee: values["obrada-min"],
        defaultProcessingFee: values["obrada-def"],
        maxProcessingFee: values["obrada-max"],
        minInterestRate: values["kamata-min"],
        defaultInterestRate: values["kamata-def"],
        maxInterestRate: values["kamata-max"],
        minPhysicalInterestRate: values.fizička,
        olInterestRate: values["kamata-OL"],
        commission: values.provizija,
      },
      brands: opstiPodaci.brand,
    };

    isAddSupplier
      ? actions.registerSupplier(dobavljac)
      : actions.updateSupplierById(dobavljac, supplierState.id);
  };

  return (
    <>
      <div className="px-7 pt-6 pb-[7px]">
        <Title className="text-dark-blue text-lg font-bold mb-4">
          NAZIV KOMPANIJE (DOBAVLJAČA)
        </Title>
        <Text
          className={`mr-5 ${
            !finansijskiPodaciForm &&
            "text-light-blue-login border-b-2 border-light-blue-login pb-2"
          }`}
        >
          Opšti podaci
        </Text>
        <Text
          className={`${
            finansijskiPodaciForm &&
            "text-light-blue-login border-b-2 border-light-blue-login pb-2"
          }`}
        >
          Finansijski podaci
        </Text>
      </div>
      <div className="h-6 bg-padding-white"></div>

      <Form {...layout} form={form} name="basic" onFinish={onFinish}>
        {!finansijskiPodaciForm ? (
          <OpstiPodaci
            supplierState={supplierState}
            goForward={goForward}
            brands={brands}
          />
        ) : (
          <FinansijskiPodaci supplierState={supplierState} goBack={goBack} />
        )}
      </Form>
    </>
  );
};

export default AddEditForm;
